import {
	WportError, WportHttpError, WportNetworkError, WportInvalidArgumentError, isWportError,
} from '@wport/core';

export const ExitCode = {
	Success: 0,
	InvalidArgument: 2,
	ServerClientError: 3,
	ServerOrNetworkError: 4,
	ConfigCorrupt: 5,
} as const;

export type ExitCodeValue = (typeof ExitCode)[keyof typeof ExitCode];

export class CliError extends Error {
	readonly exitCode: ExitCodeValue;

	constructor(message: string, exitCode: ExitCodeValue) {
		super(message);
		this.name = 'CliError';
		this.exitCode = exitCode;
	}
}

export class InvalidArgumentError extends CliError {
	constructor(message: string) {
		super(message, ExitCode.InvalidArgument);
		this.name = 'InvalidArgumentError';
	}
}

export class ConfigCorruptError extends CliError {
	readonly path?: string;
	constructor(message: string, path?: string) {
		super(message, ExitCode.ConfigCorrupt);
		this.name = 'ConfigCorruptError';
		this.path = path;
	}
}

export function isCliError(err: unknown): err is CliError {
	return err instanceof CliError;
}

/** core 拋的 WportError（無 exitCode）→ CLI exit code。CliError 自己帶 exitCode，不走這裡。 */
export function exitCodeForError(err: unknown): ExitCodeValue {
	if (err instanceof WportInvalidArgumentError) return ExitCode.InvalidArgument;
	if (err instanceof WportHttpError) {
		return err.status >= 400 && err.status < 500 ? ExitCode.ServerClientError : ExitCode.ServerOrNetworkError;
	}
	if (err instanceof WportNetworkError) return ExitCode.ServerOrNetworkError;
	return ExitCode.ServerOrNetworkError;
}

// core 類 alias：保留舊名的 instanceof 身分（resume-orchestrator/apply/company 等的 catch 靠這個對得上 core 拋的錯）。
export { WportError, WportHttpError, WportNetworkError, WportInvalidArgumentError, isWportError };
export const ServerClientHttpError = WportHttpError;
export const NetworkError = WportNetworkError;
